import type { ModelWithNetStats } from '@cadstrom/sigma-engine-shared';
import type { CommandBarProviderProps } from '#components/command-bar/command-bar-types.js';

export const NET_SEARCH_PREFIX = '#';
export const NET_SEARCH_PROVIDER_ID = 'net-search';

export interface NetSearchProviderProps extends CommandBarProviderProps {
	coreModel: ModelWithNetStats;
}
